import { render, staticRenderFns } from "./articles_status.vue?vue&type=template&id=496703d9"
import script from "./articles_status.vue?vue&type=script&lang=js"
export * from "./articles_status.vue?vue&type=script&lang=js"
import style0 from "./articles_status.vue?vue&type=style&index=0&id=496703d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports